var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequirementsTagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17,
    height: 15,
    viewBox: "9.5 9.5 17.2 15.2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning-icon 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0843 10L26.1497 24.1667H10.0189L18.0843 10Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.7926 15.7083C18.7926 15.3171 18.4748 15 18.0829 15C17.6909 15 17.3732 15.3171 17.3732 15.7083V19.5417C17.3732 19.9329 17.6909 20.25 18.0829 20.25C18.4748 20.25 18.7926 19.9329 18.7926 19.5417V15.7083Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.0829 22.8335C18.5901 22.8335 19.0013 22.4231 19.0013 21.9168C19.0013 21.4106 18.5901 21.0002 18.0829 21.0002C17.5757 21.0002 17.1645 21.4106 17.1645 21.9168C17.1645 22.4231 17.5757 22.8335 18.0829 22.8335Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirementsTagIcon);
export default __webpack_public_path__ + "static/media/RequirementsTagIcon.0b8c17299e05d83f176a1de8cbcb9973.svg";
export { ForwardRef as ReactComponent };